import { ArrowRight, Home, Wrench, Layers, Square, Droplets, CloudLightning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";

const services = [
  {
    title: "Roof Replacement",
    description: "Complete roof replacement using premium materials built to withstand Minnesota's toughest weather.",
    href: "/services/roof-replacement",
    icon: Home,
  },
  {
    title: "Roof Repair",
    description: "Fast, reliable roof repairs to fix leaks, storm damage, and wear — extending the life of your roof.",
    href: "/services/roof-repair",
    icon: Wrench,
  },
  {
    title: "Siding",
    description: "Transform your home's exterior with durable siding solutions that protect and beautify for decades.",
    href: "/services/siding",
    icon: Layers,
  },
  {
    title: "Windows",
    description: "Energy-efficient window installation and replacement to improve comfort and reduce utility costs.",
    href: "/services/windows",
    icon: Square,
  },
  {
    title: "Gutters",
    description: "Seamless gutter installation and repair to protect your home's foundation and landscaping.",
    href: "/services/gutters",
    icon: Droplets,
  },
  {
    title: "Storm Damage",
    description: "24-hour emergency response with full insurance claim support — from tarping to total restoration.",
    href: "/services/storm-damage",
    icon: CloudLightning,
  },
];

export const WhatWeDo = () => {
  return (
    <section className="py-20 bg-[#1A1A1A]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight">
              WHAT WE DO
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-white/80 text-lg leading-relaxed">
              From full roof replacements to new gutters, Kodiak Structures & Exteriors handles every aspect of your home's exterior. We use premium materials and proven techniques to deliver results that stand up to Minnesota's toughest seasons.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.href}
              className="group p-6 rounded-xl border border-secondary/30 bg-secondary hover:bg-secondary/90 transition-all duration-300"
            >
              <service.icon className="w-8 h-8 text-white mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="text-lg font-heading font-bold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-white/75 leading-relaxed text-sm mb-4">
                {service.description}
              </p>
              <span className="inline-flex items-center text-sm font-semibold text-white group-hover:gap-2 gap-1 transition-all">
                Learn More <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>

        <Link to="/services">
          <Button className="font-semibold font-subheading bg-white text-secondary hover:bg-white/90">
            All Services <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </section>
  );
};
